<template>
  <div class="verification-container">
    <div
      class="send-btn"
      :class="{ disabled: isCountingDown }"
      @click="sendCode"
    >
      {{ isCountingDown ? `Resend(${countdown}s)` : 'Get Code' }}
    </div>
  </div>
</template>
<script>
export default {
    name:'CountDown',
    props: {
      mobile: {
        type: [String, Number],
        default: ''
      }
    },
    data() {
    return {
      code: '',
      countdown: 60, // 倒计时秒数
      isCountingDown: false, // 是否正在倒计时
      timer: null // 定时器实例
    };
  },
  created() {
    // 页面加载时检查是否有保存的倒计时状态
    this.checkCountdownStatus();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    // 检查本地存储中的倒计时状态
    checkCountdownStatus() {
      const storedEndTime = localStorage.getItem('verifyCodeEndTime');
      if (storedEndTime) {
        const now = Date.now();
        const endTime = parseInt(storedEndTime);
        const remainingSeconds = Math.ceil((endTime - now) / 1000);
        // 如果还在倒计时范围内
        if (remainingSeconds > 0) {
          this.isCountingDown = true;
          this.countdown = remainingSeconds;
          this.startCountdown();
        } else {
          // 倒计时已结束，清除存储
          this.clearStorage();
        }
      }
    },
    // 发送验证码
    async sendCode() {
      if (this.isCountingDown) return
      const mobile = String(this.mobile || '').trim()
      if (!mobile) {
        this.$toast ? this.$toast('Please enter phone number first') : (this.$message && this.$message.error('Please enter phone number first'))
        return
      }
      try {
        const res = await this.$api.sendCode({ mobile })
        const ok = res && (res.code === 1 || res.code === 200)
        if (!ok) {
          const msg = (res && (res.msg || res.message)) ? String(res.msg || res.message) : 'Failed to send verification code'
          this.$toast ? this.$toast(msg) : (this.$message && this.$message.error(msg))
          return
        }
        this.$toast ? this.$toast('Verification code sent') : (this.$message && this.$message.success('Verification code sent'))
        // 接口成功后才开始倒计时
        this.isCountingDown = true;
        this.countdown = 60;
        const endTime = Date.now() + this.countdown * 1000;
        localStorage.setItem('verifyCodeEndTime', endTime.toString());
        this.startCountdown();
      } catch (e) {
        // request 层可能已提示，这里不重复弹
      }
    },
    // 开始倒计时
    startCountdown() {
      // 清除可能存在的定时器
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          // 倒计时结束
          this.endCountdown();
        }
      }, 1000);
    },
    // 结束倒计时
    endCountdown() {
      clearInterval(this.timer);
      this.timer = null;
      this.isCountingDown = false;
      this.countdown = 60;
      this.clearStorage();
    },
    // 清除本地存储
    clearStorage() {
      localStorage.removeItem('verifyCodeEndTime');
    }
  }
};
</script>
<style scoped>
.verification-container {
  display: flex;
  align-items: center;
  height: 100%;
}
.send-btn {
  min-width: 96px;
  height: 100%;
  padding: 0 14px;
  border: none;
  border-left: none;
  background: #fff;
  color: #1e3c3e;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  cursor: pointer;
}
.send-btn.disabled {
  color: #9aa3ad;
  cursor: not-allowed;
}
.send-btn:not(.disabled):hover {
  color: #315f62;
}
</style>
